<!-- 表情包控件 by LLQ 2019/4/15-->
<template>
	<div class="emoji">
    <p @click="checkEmoji(item.title)" class="emoji_p" v-for="item in emojiList">
      <img class="emoji_Img" :src="item.url" alt="">
    </p>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				emojiList:[
          {
            title:'[em_0]',
            url:require('../../../static/emoji/0.png')
            },
          {
            title:'[em_1]',
            url:require('../../../static/emoji/1.png')
            },
            {
            title:'[em_2]',
            url:require('../../../static/emoji/2.png')
            },
            {
            title:'[em_3]',
            url:require('../../../static/emoji/3.png')
            },
            {
            title:'[em_4]',
            url:require('../../../static/emoji/4.png')
            },
            {
            title:'[em_5]',
            url:require('../../../static/emoji/5.png')
            },
            {
            title:'[em_6]',
            url:require('../../../static/emoji/6.png')
            },
            {
            title:'[em_7]',
            url:require('../../../static/emoji/7.png')
            },
            {
            title:'[em_8]',
            url:require('../../../static/emoji/8.png')
            },
            {
            title:'[em_9]',
            url:require('../../../static/emoji/9.png')
            },
            {
            title:'[em_10]',
            url:require('../../../static/emoji/10.png')
            },
            {
            title:'[em_11]',
            url:require('../../../static/emoji/11.png')
            },
            {
            title:'[em_12]',
            url:require('../../../static/emoji/12.png')
            },
            {
            title:'[em_13]',
            url:require('../../../static/emoji/13.png')
            },
            {
            title:'[em_14]',
            url:require('../../../static/emoji/14.png')
            },
            {
            title:'[em_15]',
            url:require('../../../static/emoji/15.png')
            },
            {
            title:'[em_16]',
            url:require('../../../static/emoji/16.png')
            },
            {
            title:'[em_17]',
            url:require('../../../static/emoji/17.png')
            },
            {
            title:'[em_18]',
            url:require('../../../static/emoji/18.png')
            },
            {
            title:'[em_19]',
            url:require('../../../static/emoji/19.png')
            },
            {
            title:'[em_20]',
            url:require('../../../static/emoji/20.png')
            },
            {
            title:'[em_21]',
            url:require('../../../static/emoji/21.png')
            },
            {
            title:'[em_22]',
            url:require('../../../static/emoji/22.png')
            },
            {
            title:'[em_23]',
            url:require('../../../static/emoji/23.png')
            },
            {
            title:'[em_24]',
            url:require('../../../static/emoji/24.png')
            },
            {
            title:'[em_25]',
            url:require('../../../static/emoji/25.png')
            },
            {
            title:'[em_26]',
            url:require('../../../static/emoji/26.png')
            },
            {
            title:'[em_27]',
            url:require('../../../static/emoji/27.png')
            },
            {
            title:'[em_28]',
            url:require('../../../static/emoji/28.png')
            },
            {
            title:'[em_29]',
            url:require('../../../static/emoji/29.png')
            },
            {
            title:'[em_30]',
            url:require('../../../static/emoji/30.png')
            },
            {
            title:'[em_31]',
            url:require('../../../static/emoji/31.png')
            },
            {
            title:'[em_32]',
            url:require('../../../static/emoji/32.png')
            },
            {
            title:'[em_33]',
            url:require('../../../static/emoji/33.png')
            },
            {
            title:'[em_34]',
            url:require('../../../static/emoji/34.png')
            },
            {
            title:'[em_35]',
            url:require('../../../static/emoji/35.png')
            },

        ]
			}
		},
		methods: {
      checkEmoji(title){
         this.$emit("emojiData",title)
      }
		}
	}
</script>

<style>
 @import url("emoji.css");
</style>



// WEBPACK FOOTER //
// src/components/emoji/emoji.vue